import { Component } from '@ecs/Component';

export class Position implements Component {
  readonly type = 'Position';

  constructor(
    public x: number = 0,
    public y: number = 0
  ) {}
}